module.exports = __webpack_public_path__ + "static/media/copy.64a05e88.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/copy.png
// module id = 1392
// module chunks = 0